import React, { useState } from "react";
import {
  Button,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";

import TncContent from "./newTNCContent";

const TNCModal = ({ open, showLoading, onClickSubmit, onChangeHOC }) => {
  const [ checked, onToggleCheck ] = useState( false );
  const [ showPrivacyModal, onTogglePrivacy ] = useState( false );

  return (
    <Modal
      centered={ true }
      scrollable={ true }
      contentClassName={ "mh-100" }
      style={{ margin: 0, maxWidth: "100%", maxHeight: "100vh" }}
      isOpen={ open }
      toggle={ () => onChangeHOC( false, "showTNCModal" ) }
    >
      <ModalHeader>Electronic Signature Agreement</ModalHeader>
      <ModalBody className="tnc-modal-body">
        <p className={ 'd-flex mb-2 mt-2' }>
          We take every precaution to protect your privacy and data and we only use the data that you provide for the 
          purpose of eSigning this document and the property case and will not share it with anyone else unnecessarily.
        </p>
        <p>
          By selecting the "I agree to the terms of the Electronic Signature Agreement" checkbox, you are signing this Agreement electronically. 
          You agree your electronic signature is the legal equivalent of your manual signature on this Agreement. 
          By selecting “I agree to the terms of the Electronic Signature Agreement” you consent to be legally bound by this Agreement’s terms and conditions. 
          You further agree that your use of a key pad, mouse or other device to select an item, button, icon or similar 
          act/action, or to otherwise provide IQI instructions or in accessing or making any transaction regarding 
          any agreement, acknowledgement, consent terms, disclosures or conditions constitutes your signature 
          (hereafter referred to as “E-Signature”), acceptance and agreement as if actually signed by you in writing. 
          You also agree that no certification authority or other third party verification is necessary to validate your 
          E-Signature and that the lack of such certification or third party verification will not in any way affect the 
          enforceability of your E-Signature or any resulting contract between you and IQI. You also represent that you 
          are authorized to enter into this Agreement for all persons who own or are authorized to access any of your 
          accounts and that such persons will be bound by the terms of this Agreement.
        </p>
        <p className="mt-2">
          { `By ticking the tickbox, I agree to the ` }
          <a 
            style={{ textDecoration: 'underline', color: '#3f8dde', cursor: 'pointer' }} 
            onClick={ () => onTogglePrivacy( true ) }
          >
            { `privacy policy` }
          </a>
          .
        </p>
        <hr />
        <FormGroup check>
          <Input
            type="checkbox"
            checked={ checked }
            onChange={ e => onToggleCheck( e.target.checked ) }
          />
          <Label for="exampleCheck" check>
            I agree to the terms of the Electronic Signature Agreement
          </Label>
        </FormGroup>
        <div className={ "d-flex" }>
          {
            !showLoading && (
              <Button
                disabled={ !checked }
                className={ 'mt-2' }
                color="primary"
                onClick={ () => onClickSubmit() }
              >
                I agree with the terms and condition above
              </Button>
            )
          }
          { showLoading && <Spinner className={"ml-auto"} color="primary" /> }
        </div>
        <Modal
          centered={ true }
          scrollable={ true }
          contentClassName={ "mh-100" }
          style={{ margin: 0, maxWidth: "100%", maxHeight: "100vh" }}
          isOpen={ showPrivacyModal }
          toggle={ () => onTogglePrivacy( false ) }
        >
          <ModalHeader toggle={ () => onTogglePrivacy( false ) }>
            Privacy Policy
          </ModalHeader>
          <ModalBody>
            <TncContent />
          </ModalBody>
        </Modal>
      </ModalBody>
    </Modal>
  );
};

export default TNCModal;
